module.exports = __webpack_public_path__ + "z-guarantee-26TL-79.svg";